import type {
  iBooking,
  iCustomerInvoice,
  iCustomerPaymentReceipt,
  iPricingAndPaymentsPlan,
} from "./booking-model";
export { getReceiptHolidayAmount } from "./booking-model";

const emptyPlan = (): iPricingAndPaymentsPlan => ({
  pricingBreakdown: {
    sellingCurrency: "GBP",
    totalCost: 0,
    lineItems: [],
  },
  paymentPlan: {
    type: "UPFRONT_PAYMENT",
    paymentSchedule: [],
  },
});

export function isCustomerInvoiceCreated(
  booking: iBooking | null | undefined
): boolean {
  return (
    booking?.pricingAndPayments?.isCustomerInvoiceCreated === true ||
    !!booking?.pricingAndPayments?.customerInvoiceId
  );
}

export function getBookingDraftPlan(
  booking: iBooking | null | undefined
): iPricingAndPaymentsPlan {
  return booking?.pricingAndPayments?.draft ?? emptyPlan();
}

export function getActiveCustomerPlan(
  booking: iBooking | null | undefined,
  invoice?: iCustomerInvoice | null
): iPricingAndPaymentsPlan {
  const confirmedWithAmendedPrice = (booking?.amendments ?? []).filter(
    (a) =>
      a.status === "CONFIRMED" && a.amendedPrice?.pricingBreakdown != null
  );
  if (confirmedWithAmendedPrice.length > 0) {
    const latest = confirmedWithAmendedPrice.reduce((best, a) =>
      (a.confirmedAt ?? 0) >= (best.confirmedAt ?? 0) ? a : best
    );
    const plan = latest.amendedPrice!;
    return {
      pricingBreakdown: plan.pricingBreakdown,
      paymentPlan: plan.paymentPlan ?? emptyPlan().paymentPlan,
    };
  }

  if (invoice) {
    return {
      pricingBreakdown: invoice.pricingBreakdown,
      paymentPlan: invoice.paymentPlan,
    };
  }
  return getBookingDraftPlan(booking);
}

export function getNonVoidedReceipts(
  receipts: iCustomerPaymentReceipt[] | null | undefined
): iCustomerPaymentReceipt[] {
  return (receipts ?? []).filter((r) => r.voided !== true);
}
